"use client";

import RouteLoading from "@/components/RouteLoading/RouteLoading";

export default function LoadingPage() {
  return <RouteLoading fullHeight />;
}
